module.exports = __webpack_public_path__ + "img/idcard.a7d3b4fb.png";